import React from 'react';
import { PARTNERS } from '../../data/mock';
import { Utensils, HeartPulse, Building2, ExternalLink, Handshake } from 'lucide-react';

const iconMap = {
  Utensils,
  HeartPulse,
  Building2
};

export const Partners = () => {
  return (
    <section className="py-16 md:py-20 bg-slate-50 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm uppercase tracking-wider mb-4">
            <Handshake className="w-5 h-5" />
            Trusted Partners
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">
            {PARTNERS.title}
          </h2>
          <p className="text-slate-600">
            {PARTNERS.subtitle}
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {PARTNERS.partners.map((partner, index) => {
            const IconComponent = iconMap[partner.icon];
            return (
              <a
                key={index}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl p-6 border border-slate-200 hover:border-teal-300 hover:shadow-lg transition-all duration-300 flex items-center gap-4"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-slate-800 group-hover:text-teal-600 transition-colors flex items-center gap-2">
                    {partner.name}
                    <ExternalLink className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </h3>
                  <p className="text-sm text-slate-500">{partner.description}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
